const SESSION_KEY = "attar.session.v1";
const SESSION_VERSION = 1;
const ROLES = ["student", "staff", "superuser"];
const listeners = new Set();
let currentSession;
let locallyRevokedToken = null;

/** @returns {import("../api/generated/migration").components["schemas"]["Session"]} */
export function validateSession(value) {
  const user = value?.user;
  if (
    typeof value?.token !== "string" || !value.token.trim() ||
    !user || typeof user.username !== "string" || !user.username.trim() ||
    !ROLES.includes(user.role) ||
    !(value.expiry === null || typeof value.expiry === "string")
  ) {
    throw new Error("پاسخ ورود معتبر نیست. لطفاً با پشتیبانی تماس بگیرید.");
  }

  // Persist only the completed session, never credentials or setup secrets.
  return {
    token: value.token,
    expiry: value.expiry,
    user: {
      username: user.username,
      first_name: typeof user.first_name === "string" ? user.first_name : "",
      last_name: typeof user.last_name === "string" ? user.last_name : "",
      is_staff: user.is_staff === true,
      is_superuser: user.is_superuser === true,
      role: user.role,
    },
  };
}

function readStoredSession() {
  try {
    const stored = JSON.parse(window.localStorage.getItem(SESSION_KEY));
    return stored?.version === SESSION_VERSION && stored.session?.token !== locallyRevokedToken
      ? validateSession(stored.session)
      : null;
  } catch {
    return null;
  }
}

function notify() {
  listeners.forEach((listener) => listener());
}

export function getSession() {
  if (currentSession === undefined) currentSession = readStoredSession();
  return currentSession;
}

export function saveSession(value) {
  const session = validateSession(value);
  try {
    window.localStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ version: SESSION_VERSION, session })
    );
  } catch {
    throw new Error("ذخیره نشست ممکن نیست. دسترسی مرورگر به فضای ذخیره‌سازی را بررسی کنید.");
  }
  locallyRevokedToken = null;
  currentSession = session;
  notify();
  return session;
}

export function clearSession() {
  locallyRevokedToken = getSession()?.token || locallyRevokedToken;
  currentSession = null;
  let storageCleared = true;
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch {
    storageCleared = false;
  }
  notify();
  return storageCleared;
}

function onStorage(event) {
  if (event.key !== SESSION_KEY && event.key !== null) return;
  currentSession = readStoredSession();
  notify();
}

// The auth provider subscribes for its entire mounted lifetime.
export function subscribeSession(listener) {
  if (listeners.size === 0) window.addEventListener("storage", onStorage);
  listeners.add(listener);
  const stored = readStoredSession();
  if (JSON.stringify(stored) !== JSON.stringify(getSession())) { currentSession = stored; notify(); }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) window.removeEventListener("storage", onStorage);
  };
}

// The backend extends active sessions; the stored expiry is informational.
export function panelPath(session) {
  if (!session) return "/";
  if (session.user.role === "student") return "/dashboard/home";
  return ["staff", "superuser"].includes(session.user.role) ? "/admin/groups" : "/";
}
